// @ts-nocheck
import { useState } from "react";
import { useEffect } from "react";
import { createContext } from "react";
import { useLocation } from "react-router-dom";
import { URLS } from "../../utils/constants/urls";
import PropTypes from "prop-types";
import { useContext } from "react";

export const PreviousRouteContext = createContext({
  previous: null,
});

export default function PreviousRouteProvider({ children }) {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState(null);

  useEffect(() => {
    if (location.pathname?.includes(URLS.ADMIN.EVENT.SOW)) {
      setPreviousPath(URLS.ADMIN.EVENT.SOW);
    } else if (location.pathname?.includes(URLS.ADMIN.EVENT.PO)) {
      setPreviousPath(URLS.ADMIN.EVENT.PO);
    } else if (location.pathname?.includes(URLS.ADMIN.EVENT.FREELANCE_PO)) {
      setPreviousPath(URLS.ADMIN.EVENT.PO);
    } else {
      setPreviousPath(null);
    }
  }, [location]);

  return (
    <PreviousRouteContext.Provider
      value={{
        previous: previousPath,
      }}
    >
      {children}
    </PreviousRouteContext.Provider>
  );
}

export const usePreviousRouteContext = () => {
  return useContext(PreviousRouteContext);
};

PreviousRouteProvider.propTypes = {
  children: PropTypes.node,
};